module.exports = __webpack_public_path__ + "resources/img/solution_game_management.47fffbb266d1314f645cd04c180f8fc3.png";